module.exports = __webpack_public_path__ + "img/广告图2.dc5169ec.jpg";